import { gql } from 'graphql-request'

export const QueryBlockPricingCards = gql`
  fragment FragmentBlockPricingCards on BlockPricingCardsModelRecord {
          __typename
          id
          title
          annualDiscount
          action {
            ...FragmentNavigationItem
          }
          description {
            value
          }
          monthlyFooter {
            value
          }
          annualFooter {
            value
          }
          tierTag
          pricingCards {
            id
            title
            price
            image { 
              title
              url
              alt
            }
            billingType
            pricingTier
            action {
              ...FragmentNavigationItem
            }
            description {
              value
            }
            bulletPoints {
              id
              icon
              title
              description {
                value
              }
            }
          }
          moreSolutions {
            managementTitle
            title
            anchor
            featureCards {
              ...FragmentFeatureCardBlock
              price
            }
          }
          secondaryCards {
              id
              title
              description {
                value
              }
              action {
                ...FragmentNavigationItem
              }
          }
        }
`

export const BlockPricingCards = {
  __typename: 'BlockPricingCards',
  fragmentName: 'FragmentBlockPricingCards',
  fragmentQuery: QueryBlockPricingCards,
  fragments: ['FragmentNavigationItem', 'FragmentFeatureCardBlock']
}
